<template>
  <!--
  <span class="e-badge e-badge-overlap e-badge-notification">{{value}}</span>
-->
  <div style="position:relative;display:inline-block;margin:10px 10px 0 10px;align-self: flex-end">
    <slot />
    <span
      :class="_class"
    >{{ value }}</span>
  </div>
</template>

<script setup lang="ts">

import {computed} from "vue";

interface Props {
  value?: string | number
  badgeStyle?: string
  badgeType?: string
  overlap?: string | boolean // only notification or dot
}

const props = withDefaults(defineProps<Props>(), {
    value: undefined,
    badgeStyle: undefined,
    badgeType: undefined,
    overlap: undefined
  }
)


const _class = computed(() => {
  let t_c = "e-badge"
  switch (props.badgeStyle) {
    case "primary" :
      t_c += " e-badge-primary";
      break;
    case "secondary" :
      t_c += " e-badge-secondary";
      break;
    case "success" :
      t_c += " e-badge-success";
      break;
    case "danger" :
      t_c += " e-badge-danger";
      break;
    case "warning" :
      t_c += " e-badge-warning";
      break;
    case "info" :
      t_c += " e-badge-info";
      break;
    case "light" :
      t_c += " e-badge-light";
      break;
    case "dark" :
      t_c += " e-badge-dark";
      break;
  }
  switch (props.badgeType) {
    case "circle":
      t_c += " e-badge-circle";
      break;
    case "pill":
      t_c += " e-badge-pill";
      break;
    case "notification":
      t_c += " e-badge-notification";
      break;
    case "dot":
      t_c += " e-badge-dot";
      break;
  }
  if (props.overlap) {
    t_c += " e-badge-overlap";
  }

  /*
    const instance = getCurrentInstance();
    console.log("parent:");
    console.log(instance?.parent?.style);
    instance.parent.style = "position:relative;display:inline-block;margin:20px 20px 10px 20px;"
    console.log(instance?.parent?.style);
  */
  return t_c
})


</script>

<style scoped>

</style>
